import { useQuery } from "@tanstack/react-query";
import { OrdersService } from "@/services/orders/orders-service";
import { Order } from "@/services/orders/orders.types";

const OPEN_STATUSES = ["NEW", "PROCESSING", "PENDING_APPROVAL", "APPROVED", "PENDING_SHIPPING", "SHIPPED"];

const ordersService = new OrdersService();

export const useOpenOrders = () => {
  return useQuery<Order[], Error>({
    queryKey: ["open-orders"],
    queryFn: async () => {
      const response = await ordersService.getMyOrders();
      const orders = response.orders ?? [];
      return orders.filter((order) => OPEN_STATUSES.includes(order.status ?? ""));
    },
  });
};
